export default "__VITE_ASSET__6af23ece__"